;(function (angular, _, moment) {
  'use strict'

  var DEFAULT_TITLE = 'SUFATECH'

  angular
    .module('kilo.common.directives')
    .directive('zlTitle', TitleDirective)

  function TitleDirective ($rootScope) {
    return {
      restrict: 'E',
      controllerAs: 'title',
      bindToController: {},
      scope: {},
      template: '{{title.title}}',
      controller: ['$rootScope', function ($rootScope) {
        var self = this
        self.$onInit = () => {
          _.extend(self, {
            getTitle: getTitle
          })
        }
        self.title = DEFAULT_TITLE

        $rootScope.$on('$stateChangeSuccess', function (event, toState) {
          self.title = toState.title || DEFAULT_TITLE
        })

        $rootScope.$on('$stateChangeError', function () {
          self.title = DEFAULT_TITLE
        })

        function getTitle () {
          return self.title
        }

      }]
    }
  }
})(window.angular, window._, window.moment)
